<script setup>
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { useAppUpdateStore } from '@/stores/appUpdate'

const { t } = useI18n({
  messages: {
    fr: {
      title: 'Mise à jour disponible',
      message: "Une nouvelle version de l'application est disponible.",
      warning:
        'Attention : ignorer cette mise à jour peut causer des problèmes de compatibilité ou des erreurs de chargement. Il est recommandé de recharger dès que possible.',
      reloadNow: 'Recharger maintenant',
      dismiss: 'Ignorer'
    },
    en: {
      title: 'Update Available',
      message: 'A new version of the application is available.',
      warning:
        'Warning: Dismissing this update may cause compatibility issues or loading errors. It is recommended to reload as soon as possible.',
      reloadNow: 'Reload Now',
      dismiss: 'Dismiss'
    }
  }
})

const appUpdateStore = useAppUpdateStore()
const { showUpdateSnackbar } = storeToRefs(appUpdateStore)

const handleReload = () => {
  appUpdateStore.confirmUpdate()
}

const handleDismiss = () => {
  appUpdateStore.dismissUpdate()
}
</script>

<template>
  <!-- Non-intrusive snackbar notification instead of blocking dialog -->
  <v-snackbar
    v-model="showUpdateSnackbar"
    location="bottom"
    :timeout="-1"
    class="app-update-snackbar"
    multi-line
  >
    <div class="d-flex align-start">
      <v-icon icon="mdi-alert" class="mt-1 mr-3 flex-shrink-0" />
      <div class="flex-grow-1">
        <div class="font-weight-bold mb-2">{{ t('title') }}</div>
        <div class="text-caption">{{ t('message') }}</div>
        <div class="text-caption text-warning mt-2">{{ t('warning') }}</div>
      </div>
    </div>

    <template v-slot:actions>
      <v-btn size="small" variant="text" @click="handleDismiss" color="white">
        {{ t('dismiss') }}
      </v-btn>
      <v-btn size="small" variant="tonal" @click="handleReload" color="white">
        {{ t('reloadNow') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>
